'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { DASHBOARD_STATS } from '@/lib/mockData';

export default function DashboardKPIs() {
  const downloadPct = Math.round((DASHBOARD_STATS.downloadsUsed / DASHBOARD_STATS.downloadsLimit) * 100);
  const isApproachingLimit = downloadPct >= 68;

  const cards = [
    {
      id: 'kpi-downloads',
      label: 'Downloads Used',
      value: `${DASHBOARD_STATS.downloadsUsed}/${DASHBOARD_STATS.downloadsLimit}`,
      sub: `${100 - DASHBOARD_STATS.downloadsUsed} remaining this month`,
      icon: 'ArrowDownTrayIcon',
      trend: null,
      alert: isApproachingLimit,
      progress: downloadPct,
      color: isApproachingLimit ? 'text-amber-600' : 'text-primary-600',
      bg: isApproachingLimit ? 'bg-amber-50 border-amber-200' : 'bg-white border-stone-200',
      iconBg: isApproachingLimit ? 'bg-amber-100 text-amber-600' : 'bg-primary-50 text-primary-600',
    },
    {
      id: 'kpi-favorites',
      label: 'Lessons Favorited',
      value: DASHBOARD_STATS.favoritesCount,
      sub: '3 added this week',
      icon: 'HeartIcon',
      trend: '+3',
      trendUp: true,
      alert: false,
      color: 'text-stone-800',
      bg: 'bg-white border-stone-200',
      iconBg: 'bg-red-50 text-red-500',
    },
    {
      id: 'kpi-assigned',
      label: 'LMS Assignments',
      value: DASHBOARD_STATS.lessonsAssigned,
      sub: '2 active right now',
      icon: 'AcademicCapIcon',
      trend: '+2',
      trendUp: true,
      alert: false,
      color: 'text-stone-800',
      bg: 'bg-white border-stone-200',
      iconBg: 'bg-accent-50 text-accent-600',
    },
    {
      id: 'kpi-plan',
      label: 'Subscription Status',
      value: DASHBOARD_STATS.planName,
      sub: `Renews ${DASHBOARD_STATS.planRenewal}`,
      icon: 'SparklesIcon',
      trend: null,
      alert: false,
      color: 'text-primary-700',
      bg: 'bg-primary-50 border-primary-200',
      iconBg: 'bg-primary-100 text-primary-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
      {cards.map((card) => (
        <div
          key={card.id}
          className={`rounded-2xl border p-5 shadow-card ${card.bg}`}
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${card.iconBg}`}>
              <Icon name={card.icon as any} size={20} />
            </div>
            {card.alert && (
              <div className="flex items-center gap-1 text-xs font-semibold text-amber-600 bg-amber-100 px-2 py-1 rounded-full">
                <Icon name="ExclamationTriangleIcon" size={12} />
                Low
              </div>
            )}
            {card.trend && (
              <span className={`text-xs font-semibold px-2 py-1 rounded-full ${card.trendUp ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'}`}>
                {card.trend}
              </span>
            )}
          </div>

          <p className="text-xs font-semibold text-stone-400 uppercase tracking-wider mb-1">
            {card.label}
          </p>
          <p className={`text-2xl font-bold tabular-nums ${card.color} mb-1`}>
            {card.value}
          </p>
          <p className="text-xs text-stone-500">{card.sub}</p>

          {card.progress !== undefined && (
            <div className="mt-3">
              <div className="h-1.5 bg-stone-200 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${
                    card.alert ? 'bg-amber-400' : 'bg-primary-500'
                  }`}
                  style={{ width: `${card.progress}%` }}
                />
              </div>
              <p className="text-xs text-stone-400 mt-1">{card.progress}% used</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}